var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 303 382",
    style: {
      enableBackground: "new 0 0 303 382"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.sto21837471234{fill:#5B89B5;}\n\t.aasdasfsdf{fill:#5B89B4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "sto21837471234",
    d: "M76.2,256.8h8.1c5.1,0,7.4,3,7.4,7.1c0,3.2-1.5,5.5-4.4,6.4l5.3,7.8h-5l-4.8-7.3h-2.4v7.3h-4.2V256.8z  M83.4,267.1c2.6,0,3.9-1.3,3.9-3.3c0-2-1.3-3.3-3.7-3.3h-3.2v6.5H83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sto21837471234",
    d: "M123.4,256.8h13.6v3.8h-9.4v5.1h7.6v3.7h-7.6v5h10.1v3.8h-14.2V256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sto21837471234",
    d: "M167.6,275l2.5-3.1c1.6,1.8,3.6,2.7,5.3,2.7c2,0,3-0.9,3-2.2c0-1.6-1.1-2.1-3.7-3c-3.2-1.1-6.4-2.6-6.4-6.6 c0-3.4,3-6.1,6.8-6.1c2.6,0,5.1,1,7.2,2.7l-2.5,3.2c-1.8-1.4-3.3-2.1-4.6-2.1c-1.5,0-2.5,0.8-2.6,2.1c0,1.3,1.1,1.9,3.6,2.8 c3.7,1.4,6.6,2.4,6.6,6.5c0,4.7-4.1,6.6-7.6,6.6C172.7,278.4,169.9,277.3,167.6,275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sto21837471234",
    d: "M218.1,260.6h-5.8v-3.8h16v3.8h-5.9v17.5h-4.3V260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aasdasfsdf",
    d: "M151.5,233.8c36,0,65.1-29.2,65.1-65.1c0-36-29.2-65.1-65.1-65.1s-65.1,29.2-65.1,65.1 C86.4,204.6,115.5,233.8,151.5,233.8 M107.3,209.8V165h10.2c0,0,0,26.8,0.1,53.7C113.8,216.1,110.4,213.1,107.3,209.8 M132.6,226.1 c-3.2-1.1-6.3-2.4-9.3-4c0-28.3-0.1-57.1-0.1-57.1h9.4V226.1z M148.6,229c-3.5-0.2-6.9-0.6-10.3-1.4V165h10.3V229z M124.3,159.3 c5.2-15,21.6-23,36.6-17.8c8.3,2.9,14.9,9.4,17.8,17.8H124.3z M164,227.9c-3.2,0.7-6.4,1.1-9.7,1.2V165h9.7V227.9z M180,221.9 c-3.3,1.8-6.8,3.2-10.3,4.4V165H180V221.9z M175.9,144.3c-13.4-13.5-35.3-13.5-48.7-0.1c-4.2,4.2-7.2,9.3-8.8,15h-10.5 c5.2-24.1,29-39.5,53.1-34.3c17.2,3.7,30.6,17.1,34.3,34.3h-10.5C183.1,153.6,180.1,148.5,175.9,144.3 M196,209.5 c-3.1,3.4-6.5,6.4-10.3,9V165H196V209.5z M211.7,173c-0.7,10.5-4.2,20.6-10,29.3V165h10V173z M161.3,109.4 c25.6,4.2,45.6,24.3,49.9,49.9H201c-1.9-9.9-6.7-19.1-13.9-26.2c-19.7-19.7-51.6-19.7-71.3,0c-7.1,7.1-12,16.3-13.9,26.2H91.8 C97.3,126.3,128.4,104,161.3,109.4 M101.5,165v37.7c-5.6-8.2-9.1-17.7-10.1-27.7v-10H101.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestIcon);
export default __webpack_public_path__ + "static/media/rest-icon.7e86c4075da847ef6194ef75ba5ba89f.svg";
export { ForwardRef as ReactComponent };